import React, { useEffect, useState } from "react";
import { Col, Form, Row, Tab, Tabs } from "react-bootstrap";
import toast from "react-hot-toast";
import Select from "react-select";
import { useNavigate } from "react-router-dom";
import Delete from "../../../Components/Modals/DeleteModal";
import Navbar from "../../../Components/Navbar/Navbar";
import Table from "../../../Components/TableTemplate/Table";
import AdjustmentTable from "./../../Inventory/Adjustment/AdjustmentTable";
import {
    dateFormat,
    formatDateNoTime,
    formatDate,
    numberFormat,
    refreshPage,
    toastStyle,
    getTodayDate,
    getType,
    TokenExpiry,
    getBranchId
} from "../../../Helpers/Utils/Common";
import DatePicker from "react-datepicker";
import Moment from "moment";

import { getAllFranchisee } from "../../../Helpers/apiCalls/franchiseeApi";
import { searchAttendance, deleteAttendance} from "../../../Helpers/apiCalls/Reports/DailyAttendanceApi";
import { getAllBranches } from "../../../Helpers/apiCalls/Manage/Branches";
import Footer from "../../../Components/Footer/Footer";
import TableWithDynamicPagination from "../../../Components/TableTemplate/TableWithDynamicPagination";

export default function DailyAttendanceList() {
    let navigate = useNavigate();
    var dateToday = getTodayDate();
    const accountType = getType();
    const [inactive, setInactive] = useState(true);
    const [showLoader, setShowLoader] = useState(false);
    const [sales, setSales] = useState([]);
    const [branches, setBranches] = useState([]);
    const today = Moment().format("MM/DD/YYYY");
    const [filterConfig, setFilterConfig] = useState({
        date_from: today,
        date_to: today,
        group_datetime: true,
        branch_id: (accountType === "branch_oic" || accountType === "branch_inventory_officer") ? getBranchId() : "",
        page: 1
    })
    const [totalItems, setTotalItems] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10; // Change this based on your requirement

    const handlePageChange = page => {
        setCurrentPage(page);
        setFilterConfig(prev => ({
        ...prev,
        page: page,
        }));
    };

    // SEARCH USER
    function handleOnSearch(e) {
        const { name, value } = e.target;
        setFilterConfig((prev) => {
            return { ...prev, [name]: value };
        });
    }

    function ViewBtn(row) {
        return (
            <button
                name="action"
                className="btn btn-sm view-btn-table"
                id={row.id}
                onClick={() => handlePrint(row)}
            >
                View
            </button>
        );
    }
    function handlePrint(row) {
        var dateparam = row.datetime ? row.datetime : today
        {
            window.open('/dailyattendancelist/view/branch/' + row.branch_id + "/" + dateparam + "/0/" + filterConfig.tab,'_blank')
            // navigate("/dailyattendancelist/view/" + row.branch_id, {
            //     state: { 
            //         branch_id: row.branch_id,
            //         date: row.datetime ? row.datetime : today, 
            //         // date_from: filterConfig.date_from? filterConfig.date_from : today, 
            //         // date_to: filterConfig.date_to? filterConfig.date_to : today,
            //     },
            // });
        };

    }

    const handleTabSelect = (tabKey) => {
        setFilterConfig((prev) => {
            return {
                ...prev,
                tab: tabKey,
                branch_id: "",
                date_from: today,
                date_to: today,
            };
        });
    };

    async function fetchBranches() {
        setShowLoader(true);

        const response = await getAllBranches({is_franchise: "0"});
        if (response.error) {
            setBranches([])
        } else {
            var allBranches = response.data.data.data
            .filter((data) => {
                return (data.is_franchise !== "3" && data.is_franchise !== "1")
            })
            .map((data) => {
                var branch = data;
                branch.label = data.name
                branch.value = data.id
                return branch;
            });
            if(accountType === "branch_oic" || accountType === "branch_inventory_officer") {
                var filteredBranch = allBranches.filter((data) => {
                return data.id === getBranchId()
                })
                setBranches(filteredBranch);
            } else {
                setBranches([{label: "All Branches", value:""}, ...allBranches]);
            }
        }
        setShowLoader(false);
        
    }

    async function fetchData() {
        setShowLoader(true);
        setSales([])
        setTotalItems(0)

        const response = await searchAttendance(filterConfig);
        if (response.data) {
            setTotalItems(response.data.size);
            var allBills = response.data.data.map((bill) => {
                var info = bill;
                var formattedOperationTimes = "";
                var formattedOpeningTime = "";
                var formattedClosingTime = bill.closing_time !== "" ? bill.closing_time : "Ongoing";

                if (bill.operation_time !== null) {
                    var operationTimes = bill.operation_time.split("-");
                    if (operationTimes.length === 2) {
                        var startTime = operationTimes[0].trim();
                        var endTime = operationTimes[1].trim();

                        var startHour = parseInt(startTime.split(":")[0]);
                        var endHour = parseInt(endTime.split(":")[0]);

                        var startSuffix = startHour >= 12 ? "PM" : "AM";
                        var endSuffix = endHour >= 12 ? "PM" : "AM";

                        startHour = startHour % 12 || 12;
                        endHour = endHour % 12 || 12;

                        var formattedStartTime = ("0" + startHour).slice(-2) + ":" + startTime.split(":")[1] + startSuffix;
                        var formattedEndTime = ("0" + endHour).slice(-2) + ":" + endTime.split(":")[1] + endSuffix;
                        formattedOperationTimes = formattedStartTime + " - " + formattedEndTime;
                    }
                }
                if (bill.opening_time !== null && bill.opening_time !== "") {
                    var operationTimes = bill.opening_time.split(":");
                    
                    if (operationTimes.length === 3) {
                        var startTime = operationTimes[0].trim();

                        var startHour = parseInt(startTime.split(":")[0]);

                        var startSuffix = startHour >= 12 ? "PM" : "AM";

                        startHour = startHour % 12 || 12;

                        var formattedStartTime = ("0" + startHour).slice(-2) + ":" + operationTimes[1] + startSuffix;
                        formattedOpeningTime = formattedStartTime;
                    }
                }
                if (bill.closing_time !== null && bill.closing_time !== "") {
                    var operationTimes = bill.closing_time.split(":");
                    
                    if (operationTimes.length === 3) {
                        var startTime = operationTimes[0].trim();

                        var startHour = parseInt(startTime.split(":")[0]);

                        var startSuffix = startHour >= 12 ? "PM" : "AM";

                        startHour = startHour % 12 || 12;

                        var formattedStartTime = ("0" + startHour).slice(-2) + ":" + operationTimes[1] + startSuffix;
                        formattedClosingTime = formattedStartTime;
                    }
                }

                info.datetime = Moment(bill.datetime).format("MM-DD-YYYY")
                info.opening_time = formattedOpeningTime
                info.closing_time = formattedClosingTime
                info.activity_log = formattedOpeningTime + " - " + formattedClosingTime
                info.operation_time = formattedOperationTimes
                return info;
            });
            setSales(allBills.sort((a, b) =>
                new Date(...a.datetime?.split('/').reverse()) - new Date(...b.datetime?.split('/').reverse())
            ).reverse())
        }
        setShowLoader(false);
        
    }

    useEffect(() => {
        fetchBranches();
    }, [filterConfig.tab]);

    useEffect(() => {
        fetchData();
    }, [filterConfig, currentPage]);

    return (
        <div>
            <div className="page">
                <Navbar
                    onCollapse={(inactive) => {
                        setInactive(inactive);
                    }}
                    active={"STORE REPORTS"}
                />
            </div>

            <div
                className={`manager-container ${
                    inactive ? "inactive" : "active"
                }`}
            >
                {/* headers */}
                <Row className="mb-4">
                    <Col xs={12} lg={7}>
                        <h1 className="page-title ps-2 ms-3 ms-md-0 ps-md-0 ms-md-0 fs-2"> ATTENDANCE LIST </h1>
                    </Col>
                    <Col xs={12} lg={5} className="d-flex justify-content-end force-width flex-column flex-lg-row gap-3">
                        <input
                            type="search"
                            name="branch_name"
                            placeholder="Search branch name"
                            className="search-bar"
                            onChange={handleOnSearch}
                        />
                    </Col>
                </Row>

                <div className="tab-content">
                    {/* filters */}
                    <div className="mb-3" />
                    <span className="ps-3 mb-2 align-middle d-none d-md-inline d-flex text-secondary">
                        Filter By:
                    </span>
                    <Row className="PO-filters flex flex-row mx-2 my-1">
                        <Col xs={12} lg={4} className="mb-2 mb-lg-0">
                        <Select
                            className="dropsearch-filter"
                            classNamePrefix="react-select"
                            placeholder="Select Branch"
                            styles={{
                                control: (baseStyles, state) => ({
                                ...baseStyles,
                                backgroundColor: state.isSelected ? 'white' : 'var(--primary-color)',
                                borderRadius: "7px",
                                border: "0px",
                                minHeight: "20px",
                                maxHeight: "35px",
                                }),
                                input: (baseStyles, state) => ({
                                    ...baseStyles,
                                    color: state.isSelected? "white": "white",
                                    
                                }),
                                dropdownIndicator: (baseStyles, state) => ({
                                    ...baseStyles,
                                    color: "white"
                                    
                                }),
                                singleValue: (baseStyles, state) => ({
                                    ...baseStyles,
                                    color: "white"
                                    
                                }),
                                placeholder: (baseStyles, state) => ({
                                    ...baseStyles,
                                    color: "white"
                                    
                                }),
                                
                            }}
                            // value={branchFrom}
                            options={branches}
                            onChange={(e) => { setFilterConfig((prev) => {
                                return { ...prev, branch_id: e.value };
                            });}}
                        />
                        </Col>
                        <Col xs={6} lg={2}>
                        <DatePicker
                                    autoComplete="off"
                            selected={new Date(filterConfig.date_from)}
                            name="date_from"
                            placeholderText={today}
                            onChange={(date) => {
                                setFilterConfig((prev) => {
                                    return { ...prev, date_from: date };
                                });
                            }}
                            fixedHeight
                            className="date-filter me-4 form-control"
                            showYearDropdown
                            dateFormatCalendar="MMMM"
                            yearDropdownItemNumber={20}
                            scrollableYearDropdown
                        />

                        </Col>
                        <Col xs={6} lg={2}>
                        <DatePicker
                                    autoComplete="off"
                            selected={new Date(filterConfig.date_to)}
                            name="date_to"
                            placeholderText={today}
                            onChange={(date) => {
                                setFilterConfig((prev) => {
                                    return { ...prev, date_to: date };
                                });
                            }}
                            fixedHeight
                            className="date-filter ps-label-content me-5 form-control"
                            showYearDropdown
                            dateFormatCalendar="MMMM"
                            yearDropdownItemNumber={20}
                            scrollableYearDropdown
                        />
                        </Col>
                    </Row>
                    <div className="mb-2" />

                    <div className="below">
                        <TableWithDynamicPagination
                            tableHeaders={[
                                "-",
                                "OPERATION TIME",
                                "ACTIVITY LOG",
                                "BRANCH",
                                "DATE",
                            ]}
                            headerSelector={[
                                "-", 
                                "operation_time",
                                "activity_log",
                                "branch_name",
                                "datetime",
                            ]}
                            tableData={sales}
                            ViewBtn={(row) => ViewBtn(row)}
                            showLoader={showLoader}
                            // used in dynamic pagination
                            totalItems={totalItems}
                            currentPage={currentPage}
                            itemsPerPage={itemsPerPage}
                            handlePageChange={handlePageChange}
                        />
                    </div>
                    <div className="mb-2" />
                </div>
            </div>
            <Footer/>
        </div>
    );
}
